"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServiceEmbedProperty = exports.serviceEmbedPropertyDefinition = void 0;
const models_1 = require("../models");
exports.serviceEmbedPropertyDefinition = {
    view: {
        label: 'Service embed',
        style: 'service-embed',
    },
    constraints: [
        {
            name: 'providers',
            argument: models_1.defaultServiceEmbedProviders,
        },
    ],
    type: 'service',
    multiple: false,
    name: 'service-embed',
};
const isServiceEmbedProperty = (prop) => {
    return prop.name === exports.serviceEmbedPropertyDefinition.name;
};
exports.isServiceEmbedProperty = isServiceEmbedProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmljZS1lbWJlZC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3NlcnZpY2UtZW1iZWQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0Esc0NBQXdEO0FBRTNDLFFBQUEsOEJBQThCLEdBQUc7SUFDNUMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGVBQWU7UUFDdEIsS0FBSyxFQUFFLGVBQWU7S0FDdkI7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxxQ0FBNEI7U0FDdkM7S0FDRjtJQUNELElBQUksRUFBRSxTQUFTO0lBQ2YsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsZUFBZTtDQUNVLENBQUE7QUFJMUIsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLElBQWtCLEVBQWdDLEVBQUU7SUFDekYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHNDQUE4QixDQUFDLElBQUksQ0FBQTtBQUMxRCxDQUFDLENBQUE7QUFGWSxRQUFBLHNCQUFzQiwwQkFFbEMifQ==